module.exports = __webpack_public_path__ + "static/media/cloud-slash.ee85eef7.svg";